<div class="docusign-container">
  <div *ngIf="isUser; else formPrompt">
    <div>
      <button type="submit" (click)="onSubmit()" class="btn btn-light btn-block btn-width font-weight-bold docusign-button">
        <div>
          Sign with
        </div>
        <div>
          <img src="/assets/images/docusignlogo.png" srcset="" height="20px" title="Docusign">
          <mat-icon style="color: green; font-size: 24px;" *ngIf="isDocuSigned">check</mat-icon>
        </div>
      </button>
      <p class="promptMsg">Not {{contactName}}?
        <button class="toggleForm" (click)="toggleForm()">Click Here to Switch Signer</button>
      </p>
    </div>
  </div>

  <ng-template #formPrompt>
    <form method="post" [formGroup]="docusignForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
      <div class="form-group">
        <label for="name">Name:</label>
        <input type="text" id="name" formControlName="name" class="form-control form-control-sm w-25" required>
        <div class="errors" *ngIf="name.touched">
          <div *ngIf="name.errors?.required">Name is required.</div>
        </div>

        <label for="email">Email:</label>
        <input type="email" id="email" formControlName="email" class="form-control form-control-sm w-25" required>
        <div class="errors" *ngIf="email.touched">
          <div *ngIf="email.errors?.required">Email is required.</div>
          <div *ngIf="email.errors?.email">Invalid email format.</div>
        </div>
      </div>
      <button type="submit" class="btn btn-light btn-block font-weight-bold docusign-button">
        <div>
          Sign with
        </div>
        <div>
          <img src="/assets/images/docusignlogo.png" srcset="" height="20px" title="Docusign">
          <mat-icon style="color: green; font-size: 24px;" *ngIf="isDocuSigned">check</mat-icon>
        </div>
      </button>
      <p class="promptMsg">Are you {{contactName}}?
        <button class="toggleForm" (click)="toggleForm()">Click to Sign with Pre-fill form</button>
      </p>
    </form>
  </ng-template>
</div>